export default "__VITE_ASSET__DoSPC272__"